import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import {
    IDashboardUserPermission,
} from "../../../SignalsModels";
import { useStore } from "utils/useStore";
import { ReportAccessType } from "models/Reporting/ReportAccessControls";
import { ShareWithPeople } from "./ShareWithPeople";
import { UserPermissionsList } from "./UserPermissionsList";
import { TenantVisibilitySection } from "./TenantVisibilitySection";
import useAllUserNames from "./useAllUsernames";
import { useCurrentDashboard } from "../../../useCurrentDashboard";
import { AuthStore } from "stores/AuthStore";

// Main content for the dashboard sharing dialog. Also fetches and manages user permissions.
export const SignalsShareDashboard = () => {
    const currentDashboard = useCurrentDashboard();
    const authStore = useStore(AuthStore);
    const isCurrentUserOwner =
        currentDashboard?.userVisibility === ReportAccessType.Owner;

    const [userPermissions, setUserPermissions] = React.useState<
        IDashboardUserPermission[]
    >([]);

    useEffect(() => {
        async function fetchUserPermissions() {
            if (!currentDashboard) return;
            const userPermissions =
                await currentDashboard.getDashboardUserPermissions();
            if (userPermissions) {
                setUserPermissions(userPermissions);
            }
        }
        fetchUserPermissions();
    }, [currentDashboard]);

    const { users, isLoading: usersLoading } = useAllUserNames(
        authStore.orgStore.selectedOrganization!.id,
    );

    return (
        <Grid
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2.5,
                width: "100%",
            }}
        >
            <TenantVisibilitySection
                isCurrentUserOwner={isCurrentUserOwner}
                userPermissions={userPermissions}
            />
            {isCurrentUserOwner && (
                <ShareWithPeople
                    setUserPermissions={setUserPermissions}
                    users={users}
                    usersLoading={usersLoading}
                    userPermissions={userPermissions}
                />
            )}
            {userPermissions && (
                <UserPermissionsList
                    userPermissions={userPermissions}
                    setUserPermissions={setUserPermissions}
                    users={users}
                    usersIsLoading={usersLoading}
                    isCurrentUserOwner={isCurrentUserOwner}
                />
            )}
        </Grid>
    );
};
